import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxFileUploader = _resolveComponent("DxFileUploader");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_DxFileUploader, {
                name: "file",
                ref: "fileUploader",
                "select-button-text": "Datei auswählen",
                "label-text": "Ziehen Sie die Dateien hier hinein...",
                uploadMode: "useForm",
                multiple: true,
                "chunk-size": 2097152,
                "max-file-size": 10485760,
                "allowed-file-extensions": ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.bmp'],
                onValueChanged: _cache[0] || (_cache[0] = e => _ctx.internalValue = e.value)
            }, null, 8, ["allowed-file-extensions"])
        ]),
        _: 1
    }, 16, ["name", "error-message", "label"]));
}
